import { CronEventsInterface } from '../interfaces';

import Axios from "../libraries/axios";

class CronEventsModel implements CronEventsInterface {
	[key: string]: any
	_id = '';
	eventType = '';
	data = {};
	status = '';
	triggerAt = new Date();
	internalPatientId = '';
	createdAt = new Date();

	constructor(props: CronEventsInterface) {
	  if (props) {
	    Object.assign(this, props);
	  }
	}

	static async fetchAll<ReturnType>(
	  params: any = {},
	  config: any = {}
	): Promise<ReturnType> {
	  try {
	    const { data } = await Axios.get('/api/cron-events', {
	      params,
	      ...config,
	    });

	    return data.data;
	  } catch (e: any) {
	    throw new Error(e);
	  }
	}

	static async update(
	  id: string,
	  cronEvent: Partial<CronEventsInterface>,
	): Promise<any> {
	  try {
	    const { data } = await Axios.patch(`/api/cron-events/${id}`, cronEvent);
	    return data;
	  } catch (e: any) {
	    throw new Error(e);
	  }
	}
}

export default CronEventsModel;
